export class Tags {
    public static readonly detritus = "Detritus";
    public static readonly dustbin = "Dustbin";
}